export const isNotEmpty = (value: any) => {
    return value || value === "" || value === 0;
};
